module.exports = __webpack_public_path__ + "img/icon_aside_excel3_hover.c1dd72cd.svg";